// 「なし」「いずれもなし」チェックボックスの排他制御（mypage / admin 共通）
//
// 対象: data-nothing-value="<なし系選択肢の id>" を持つチェックボックス群のコンテナ
//   - 「なし」を checked にすると、同じコンテナ内の他の項目を外して disabled にする
//   - 他の項目を 1 つでも checked にすると、「なし」を disabled にする（「なし」が checked の間は他の項目が disabled のため、両方 checked になることはない）
//   - 初期表示時にも同じルールで同期する
//
// 使い方（Slim）:
//   #container.form-checkboxes data-nothing-value=Qualification.nothing_id
//   = f.input :xxx_ids, as: :check_boxes, wrapper_html: { data: { nothing_value: Skill.nothing_id } }
$(function () {
  var CONTAINER_SELECTOR = '[data-nothing-value]'

  function sync($container) {
    var nothingValue = String($container.data('nothingValue'))
    if (!nothingValue) return

    var $checkboxes = $container.find('input[type="checkbox"]')
    var $nothing = $checkboxes.filter(function () { return this.value === nothingValue })
    var $others = $checkboxes.not($nothing)
    if (!$nothing.length) return

    var nothingChecked = $nothing.is(':checked')
    var otherChecked = $others.is(':checked')

    if (nothingChecked) {
      $others.prop('checked', false)
    } else if (otherChecked) {
      $nothing.prop('checked', false)
    }

    setDisabled($others, nothingChecked)
    setDisabled($nothing, !nothingChecked && otherChecked)
  }

  function setDisabled($checkboxes, disabled) {
    $checkboxes.prop('disabled', disabled)
    $checkboxes.each(function () {
      $(this).closest('.form-item, .form-check').find('label').toggleClass('disabled', disabled)
    })
  }

  $(CONTAINER_SELECTOR).each(function () {
    sync($(this))
  })

  $(document).on('change', CONTAINER_SELECTOR + ' input[type="checkbox"]', function () {
    sync($(this).closest(CONTAINER_SELECTOR))
  })
})
